import { render, staticRenderFns } from "./DispensationFormsDetails.vue?vue&type=template&id=d7ad8628&scoped=true&"
import script from "./DispensationFormsDetails.vue?vue&type=script&lang=js&"
export * from "./DispensationFormsDetails.vue?vue&type=script&lang=js&"
import style0 from "./DispensationFormsDetails.vue?vue&type=style&index=0&id=d7ad8628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ad8628",
  null
  
)

export default component.exports